import { IsLoggedInResponse, RegisterLoginResponse } from "@shared/types";
import { BaseRouteService } from "./BaseRouteService";

/**
 * Service to communicate with account routes of the server application
 */
export class AccountsRouteService extends BaseRouteService {
    /**
     * Log in using a name and password to the server application
     *
     * @param name Name of the user
     * @param password Password of the user
     *
     * @returns The save id of the user
     */
    public async login(name: string, password: string): Promise<RegisterLoginResponse> {
        return this.postJsonApi<RegisterLoginResponse, { name: string; password: string }>("accounts/login", {
            name,
            password,
        });
    }

    /**
     * Register a new user on the server application
     *
     * @param name Name of the user
     * @param password Password of the user
     * @param id_save ID of the save file
     *
     * @returns The save id of the user
     */
    public async register(name: string, password: string, id_save: string): Promise<RegisterLoginResponse> {
        return this.postJsonApi<RegisterLoginResponse, { name: string; password: string; id_save: string }>(
            "accounts/register",
            {
                name,
                password,
                id_save,
            }
        );
    }

    /**
     * Check if the user is currently logged in
     *
     * @returns The name and save id of the user, or `undefined` if not logged in
     */
    public async isLoggedIn(): Promise<IsLoggedInResponse | undefined> {
        const response: IsLoggedInResponse = await this.getJsonApi<IsLoggedInResponse>("accounts/is-logged-in");
        if (response.loggedIn) {
            return response;
        }
        return undefined;
    }
}
